module.exports = __webpack_public_path__ + "static/media/视频.1124067.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/视频.mp4
// module id = 34cs
// module chunks = 1